import { SVGS } from '~/assets/assetsPath';

export const contactPage = [
    {
        id: 1,
        icon: SVGS.IconLocationContact,
        label: 'Beauty-ms',
        content: '16A Le Loi, Vinh Trai Ward, Lang Son City',
    },
    {
        id: 2,
        icon: SVGS.IconPhoneContact,
        label: 'Hotline',
        content: '090 347 41 86',
    },
    {
        id: 3,
        icon: SVGS.IconEmailContact,
        label: 'Email',
        content: 'homespa@hitek.com.vn',
    },
    // {
    //     id: 4,
    //     icon: SVGS.IconMXHContact,
    // label: 'Social channels',
    //     content: [SVGS.IconFBContact, SVGS.IconZaloContact, SVGS.IconYoutubeContact, SVGS.IconInsContact],
    // },
];
